import { useLanguage } from '@/contexts/LanguageContext';
import { useOrganization } from '@/hooks/use-organization';
import { Education } from '@/components/customer/Education';

/**
 * /dashboard/customer/education (namat#36 P1-11). This page used to render
 * hard-coded sample courses with fake progress. It now shows the same real
 * courses widget as the dashboard, scoped to the active organization, so the
 * nav entry and the dashboard card can never disagree.
 */
export function EducationPage() {
  const { t } = useLanguage();
  const { selectedOrganization, loading } = useOrganization();

  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-3xl font-bold tracking-tight mb-2">{t('education.title')}</h1>
        <p className="text-muted-foreground">{t('education.description')}</p>
      </div>

      {/* Wait for the active organization so organization courses are not
          filtered out on the first load and then pop in. */}
      {!loading && <Education organizationId={selectedOrganization?.id} />}
    </div>
  );
}
